import { slideContextFactory } from '../../../components/slides/slideContextFactory';
import { AssessmentSlide } from '../../../content/assessment/components/AssessmentSlideTypes';

export const { SlideProvider: FindCareSlideProvider, useSlideContext: useFindCareSlideContext } =
  slideContextFactory<AssessmentSlide>();
